module.exports = __webpack_public_path__ + "assets/zendesk.e895767d.svg";